// libraries
import { Grid } from '@interstate/components/Grid';

// components
import BaseDealContainer from './baseDealContainer/BaseDealContainer';
import BaseDealHeader from './BaseDealHeader';
import { BaseDealLayoutContainer } from './BaseDealActivity.interstate.style';

const BaseDealActivity = () => {
    return (
        <Grid container data-testid="base-deal-central" spacing={2}>
            <BaseDealLayoutContainer xs>
                <BaseDealHeader />
                <BaseDealContainer />
            </BaseDealLayoutContainer>
        </Grid>
    );
};

export default BaseDealActivity;
